import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=3911449a&scoped=true&"
import script from "./TheSidebar.vue?vue&type=script&lang=js&"
export * from "./TheSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=3911449a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911449a",
  null
  
)

export default component.exports